import React, { useState } from "react";
import axios from "axios";
import WeatherIcon from "./WeatherIcon";

function Forecast(props) {
  let [lat, setLat] = useState(null);
  let [long, setLong] = useState(null);
  let [Foreacast_min, setForecast_min] = useState(null);
  let [Foreacast_max, setForecast_max] = useState(null);
  let [Foreacast_dt, setForecast_dt] = useState(null);
  let [Foreacast_icon, setForecast_icon] = useState(null);

  function showWeatherForecast(response) {
    setLat(response.data.coord.lat);
    setLong(response.data.coord.lon);
    setForecast_min(response.data.main.temp_min);
    setForecast_max(response.data.main.temp_max);
    setForecast_dt(response.data.dt);
    setForecast_icon(response.data.weather[0]);

    console.log(response.data);
  }

  let apiKey = "f65a157b371fdf9be7408c1f9d32dee9";

  let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${long}&appid=${apiKey}`;

  axios.get(apiUrl).then(showWeatherForecast);

  function day() {
    let dates = new Date(Foreacast_dt);
    let day = dates.getDay();
    let days = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
    return days[day];
  }
  return (
    <div className="Forecast">
      <div className="row">
        <div className="col">
          <div className="Foreacast-day">{day()} </div>
          <div className="Forecast-icon">
            <WeatherIcon code={Foreacast_icon} />
          </div>
          Longitude :{Math.round(lat)}
          <br />
          Latitude : {Math.round(long)}
          <div className="Forecast-temperature">
            <span className="Foreacast-temp-max">
              Temp-max : {Foreacast_max}
            </span>
            <br />
            <span className="Foreacast-temp-min">
              Temp-min : {Foreacast_min}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Forecast;
